var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 35.8H7.5c-2-6.8 0-11.5 0-11.5l10.6-8.2h5.7v19.7h-2.2c-.6-2.3-2.7-4-5-4a5.2 5.2 0 00-5.3 4zm23.8 0H23.7V11.1h26V36h-4.2c-.6-2.3-2.7-4-5-4s-4.8 1.6-5.4 4zM21.7 19.2h-3l-6 4.8h9v-4.8zM40.3 41a3.7 3.7 0 110-7.4 3.7 3.7 0 010 7.4zm-23.9 0a3.7 3.7 0 110-7.4 3.7 3.7 0 010 7.4z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.9c71bc60.svg";
export { ForwardRef as ReactComponent };